<template>
  <div class="dataQueries">
    <div class="main-con">
      <!--    搜索-->
      <div class="search_box">
        <el-form class="search_from">
          <el-form-item label="标签" style="margin: 0px" label-width="50px">
            <el-input v-model="tagName" @change="pageNum=1, getTableList()" placeholder="请输入标签，多个标签可以用逗号隔开" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item label="标题" style="margin: 0px 16px" label-width="50px">
            <el-input v-model="fileName" @change="pageNum=1, getTableList()" placeholder="请输入标题" style="width: 250px"></el-input>
          </el-form-item>
          <el-form-item style="margin: 0px" class="el-but">
            <el-button type="primary" icon="el-icon-search" plain @click="pageNum=1, getTableList()">查询</el-button>
            <el-button plain icon="el-icon-delete" style="margin-left: 16px" @click="getCloes">清空</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="list_quer">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            v-for="item in iconTag"
            :key="item.id"
            :label="item.name"
            :name="String(item.id)"></el-tab-pane>
        </el-tabs>
        <div v-if="activeName === '1'">
          <demonstrate :file-name="this.fileName" :tag-name="this.tagName" ref="demo"></demonstrate>
        </div>
        <div v-if="activeName === '2'">
          <bid :file-name="this.fileName" :tag-name="this.tagName" ref="demo2"></bid>
        </div>
<!--        <div v-if="activeName === '3'">-->
<!--          <certificate :file-name="this.fileName" :tag-name="this.tagName" ref="demo3"></certificate>-->
<!--        </div>-->
<!--        <div v-if="activeName === '4'">-->
<!--          <pic :file-name="this.fileName" :tag-name="this.tagName" ref="demo4"></pic>-->
<!--        </div>-->
      </div>
    </div>
    <!--    指引视频-->
    <div class="video_but" v-if="viodeShow">
      <img src="../../assets/btn_close@2x.png" class="btn" @click="viodeShow = false"/>
      <img src="../../assets/pic_videoguide@2x.png" style="width: 120px;height: 120px;padding-top: 20px" @click="videoPlay"/>
    </div>
    <!--    弹窗视频-->
    <el-dialog
      :visible.sync="dialogviode"
      width="40%"
      title="指引视频">
      <div>
        暂无指引视频。。。。。。
        <!--      <div class="videoDom">-->
        <!--        <div class="video">-->
        <!--          <video-->
        <!--            x5-playsinline="true"-->
        <!--            playsinline="true"-->
        <!--            webkit-playsinline="true"-->
        <!--            class="videodom"-->
        <!--            preload="auto"-->
        <!--            controls-->
        <!--            ref="videoNode"-->
        <!--            style="-->
        <!--                width: 100%;-->
        <!--              "-->
        <!--            :src="fileUrl"-->
        <!--          ></video>-->
        <!--        </div>-->
        <!--      </div>-->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getSceneList} from "@/api/queriesList";
import demonstrate from '@/components/queries/demonstrate'
import bid from '@/components/queries/bid'
import pic from '@/components/queries/pic'
import certificate from '@/components/queries/certificate'
export default {
  name: "newDataQueries",
  components: {
    demonstrate,
    bid,
    // pic,
    // certificate
  },
  data() {
    return {
      fileName: '', // 标题
      tagName: '', // 标签
      pageNum: 1,
      pageSize: 10,
      total: 0,
      iconTag: [
        {id:1, name: '演示资料'},
        {id:2, name: '投标资料'},
        // {id:3, name: '奖项证书'},
        // {id:4, name: '应用图库'}
      ],
      activeName: '1',
      // 视频
      dialogviode: false,
      // fileUrl: 'https://mxxxbucket.oss-cn-guangzhou.aliyuncs.com/平台使用指引视频-【业绩清单】操作流程.mp4',
      viodeShow: true,
    }
  },
  mounted() {
  },
  methods: {
    // 关闭视频
    videoPlayClose() {
      // this.$refs.videoNode.pause();
      this.dialogviode = false
      // clearTimeout()
      // this.fileUrl = ''
    },
    videoPlay() {
      this.dialogviode = true
      // this.fileUrl = 'https://mxxxbucket.oss-cn-guangzhou.aliyuncs.com/平台使用指引视频-【业绩清单】操作流程.mp4'
      // setTimeout(()=> {
      //   this.$refs.videoNode.play()
      // }, 1000)
    },
    getTableList() {
      if(this.activeName === '1'){
        this.$refs.demo.getList()
      }else if(this.activeName === '2'){
        this.$refs.demo2.getList()
      }else if(this.activeName === '3'){
        this.$refs.demo3.getAllTags()
      }else if(this.activeName === '4'){
        this.$refs.demo4.getAllTags()
      }
    },
    getCloes() {
      this.fileName = ''
      this.tagName = ''
      this.getTableList()
    },
    handleClick (tab) {
      this.$nextTick(() => {
        let ele = document.getElementsByClassName('el-tabs__active-bar')[0]
        let distance = Number(tab.index) == 0 ? 0 :  Number(tab.index) * 105 + 'px'
        ele.style.transform = `translateX(${distance})`
      })
    },
  }
}
</script>

<style scoped lang="less">
// 视频
.videoDom {
  //width: 50%;
  position: relative;
}
// 视频
.video {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
  position: relative;
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  // 遮罩层
  .video_overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }

  // 播放
  .video_play {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  video {
    vertical-align: middle;
  }
}
.btn{
  height: 30px;
  width: 30px;
  position: fixed;
  right: 40px;
  margin-bottom: 50px;

}
.video_but{
  color: white;
  position: fixed;
  right: 50px;
  bottom: 100px;
  cursor: pointer;
}
::v-deep .el-tabs__item{
  font-size: 16px;
  font-weight: bold;
  color: rgba(0,0,0,0.85);
}
::v-deep .el-tabs__active-bar{
  width: 40px !important;
  left: 8px !important;
  height: 3px !important;
}
::v-deep .el-tabs__item{
  line-height: 64px !important;
  height: 64px !important;
}
::v-deep .el-tabs__nav-scroll{
  padding-left: 24px;
}
::v-deep .el-tabs__nav-wrap::after{
  background-color: #F5F6FA !important;
}
.dataQueries {
  height: 100%;
  background-color: #F4F4F5;
  & > .main-con {
    padding: 16px 0px;
    width: 15.04rem;
    margin: 0 auto;
    min-width: 1000px;
  }
}
.search_box{
  width: 100%;
  background-color: #fff;
}
.el-form{
  //padding-right: 24px !important;
  display: flex;
  flex-wrap: wrap;
  padding: 16px 24px;
}
.list_quer{
  margin-top: 16px;
  width: 100%;
  background-color: #fff;
  padding: 16px 0px;
}
.title_tab{
  font-size: 20px;
  font-weight: bold;
  color: rgba(0,0,0,0.85);
  line-height: 28px;
}
</style>
